import http from '@/services/http'
import type * as Types from './type'

export const getWalletListApi = () => http.admin.post<Types.WalletInfoGetRespDO>('/api/wallet/admin/info/list', { sourceSystem: 'ONEWAREHOUSE' })
